<div *ngIf="hasAcces">

  <div class="widget-navigation">
    <a href="#information" class="scrollTo transition">Information</a>
  </div>

  <div>
    <form id="information" #validate="ngForm">
        <div class="widget-title margin-top-42">Roaming Community Info</div>
        <div class="widget width-49-perc margin-right-2-perc">

        <div class="info-content hide">
          <div class="widget-inner-title hide">VirtID:</div>
          <div class="widget-inner-content hide virtId">
            <input id="virtId" [value]="listInfo['virtId']" [disabled]="true" />
          </div>
        </div>

        <div class="info-content first-row">
          <div class="widget-inner-title">Name:
            <i class="fa fa-info-circle info-text"></i>
          </div>
          <div class="widget-inner-content">

            <input *ngIf="!isAdmin" value="{{listInfo['name']}}" [disabled]="true" />

            <app-input-edit *ngIf="isAdmin" validationType="name" formType="RC" saveType="name"
                          virtId="{{listInfo['virtId']}}" inputValue="{{listInfo['name']}}">
            </app-input-edit>
          </div>
        </div>

        <!--Protocol Version area-->
        <div class="info-content last-row">
          <div class="widget-inner-title">
            Protocol Version:
            <i class="fa fa-info-circle info-text"></i>
          </div>
          <div class="widget-inner-content">
            <input
              *ngIf="!isAdmin"
              value="{{ listInfo['protocolVersion'] }}"
              [disabled]="true"
            />

            <app-protocol-edit
              *ngIf="isAdmin"
              (onChange)="onProtocolVersionUpdated($event)"
              virtId="{{ listInfo['virtId'] }}"
              inputValue="{{ listInfo['protocolVersion'] }}"
              saveType="RC"
            >
            </app-protocol-edit>
          </div>
        </div>

        <div class="btn-area width-90-perc" [ngClass]="{'margin-top': !isAdmin}">
          <button class="btn btn-outline-success my-2 my-sm-0 transition" [ngClass]="{'isDisabled' : !isAdmin}"
                  [disabled]="!isAdmin" (click)="deleteModal.show()">Delete
          </button>
        </div>
        <app-delete-modal #deleteModal text="Roaming Community {{listInfo['name']}} will be deleted."
                  server="{{listInfo['virtId']}}" deleteType="roamingCommunity">
        </app-delete-modal>

      </div>
    </form>
  </div>


  <!-- Roaming Community Members -->
  <app-roaming-community-members virtId="{{listInfo['virtId']}}" name="{{listInfo['name']}}"
    protocolVersion="{{listInfo['protocolVersion']}}" (communityMembersLoadedEvent)="communityMembersLoaded($event)">
  </app-roaming-community-members>
</div>
